import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type EmployeeModel from './employee.ts';
import type TasApplicationModel from './tas-application.ts';
import type PcsCardModel from './pcs-card.ts';
import type PcsCompanyModel from './pcs-company.ts';

export interface IssuingCardholder {
  id: string;
  type: 'individual' | 'company';
  object: 'issuing.cardholder';
  status: string;
  billing?: {
    address?: {
      postal_code?: string;
    };
  };
  created: string;
  livemode: boolean;
  metadata?: Record<string, string>;

  individual?: {
    card_issuing?: {
      user_terms_acceptance?: {
        date?: string;
      };
    };
  };

  requirements?: {
    past_due: string[];
    disabled_reason?: string | null;
  };

  spending_controls?: {
    spending_limits: unknown[];
    allowed_categories: string[];
    blocked_categories: string[];
    spending_limits_currency: string | null;
    allowed_merchant_countries: string[];
    blocked_merchant_countries: string[];
  };
}

export default class PcsCardHolderModel extends Model {
  @attr declare state: string;
  @attr declare providerData: IssuingCardholder;
  @attr declare legalName: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('employee', { async: false, inverse: 'pcsCardHolders' })
  declare employee: EmployeeModel;
  @belongsTo('tas-application', { async: false, inverse: 'pcsCardHolders' })
  declare tasApplication: TasApplicationModel;
  @belongsTo('pcs-company', { async: false, inverse: null })
  declare pcsCompany: PcsCompanyModel;

  @hasMany('pcs-card', { async: false, inverse: 'pcsCardHolder' })
  declare pcsCards: PcsCardModel[];

  [Type] = 'pcs-card-holder' as const;
}
